import { render, staticRenderFns } from "./QuotationNotesTab.vue?vue&type=template&id=dd4d111e"
import script from "./QuotationNotesTab.vue?vue&type=script&lang=js"
export * from "./QuotationNotesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports